
import {
    get,
    post,
    upload
} from '@/utils/request'
const SERVICE_URL = '/contract-service/v1'

const SERVICE_URL1 = '/general-service/v1'

export function getPriceAgreementById(params, pathParam) {
    return get(SERVICE_URL + '/priceAgreement/getPriceAgreementId', params, pathParam)
}
export function getPriceAgreementListById(params, pathParam) {
    return get(SERVICE_URL + '/priceAgreement/getPriceAgreementListById', params, pathParam)
}
export function exportPartTemplate() {
    return post(SERVICE_URL + '/priceAgreement/exportPartTemplate')
}
export function getPriceAgreementList(params) {
    return post(SERVICE_URL + '/priceAgreement/getPriceAgreementList', params)
}
export function getPriceAgreementListPage(params) {
    return post(SERVICE_URL + '/priceAgreement/getPriceAgreementListPage', params)
}
export function getPriceAgreementListAccount(params) {
    return post(SERVICE_URL + '/priceAgreement/getPriceAgreementListAccount', params)
}
export function createPriceAgreement(params) {
    return post(SERVICE_URL + '/priceAgreement/create', params)
}
export function createPriceAgreementList(params) {
    return post(SERVICE_URL + '/priceAgreement/createList', params)
}
export function editPriceAgreement(params) {
    return post(SERVICE_URL + '/priceAgreement/updatePriceAgreement', params)
}
export function editPriceAgreementList(params) {
    return post(SERVICE_URL + '/priceAgreement/updatePriceAgreementList', params)
}
export function removePriceAgreement(params,pathParam) {
    return get(SERVICE_URL + '/priceAgreement/deletePriceAgreement', params,pathParam)
}
//逻辑删除零件
export function deletePriceAgreementById(params,pathParam) {
    return get(SERVICE_URL + '/priceAgreement/deletePriceAgreementById', params,pathParam)
}
//批量删除零件
export function deleteListBack(params) {
    return post(SERVICE_URL + '/priceAgreement/deleteListBack', params)
}

//提交审批
export function toApprove(params) {
    return post(SERVICE_URL + '/priceAgreement/toApprove', params)
}

//审批/驳回
export function execTask(params) {
    return post(SERVICE_URL + '/priceAgreement/execTask', params)
}


//  零件清单
export function getPriceAgreementPartListById(params, pathParam) {
    return get(SERVICE_URL + '/priceAgreementPart/getPriceAgreementPartListById', params, pathParam)
}
export function getPriceAgreementPartList(params) {
    return post(SERVICE_URL + '/priceAgreementPart/getPriceAgreementPartList', params)
}
export function createPriceAgreementPartList(params) {
    return post(SERVICE_URL + '/priceAgreementPart/insertPriceAgreementPartList', params)
}
export function editPriceAgreementPartList(params) {
    return post(SERVICE_URL + '/priceAgreement/updatePriceAgreementPartList', params)
}
export function editPriceAgreementPartListRfq(params) {
    return post(SERVICE_URL + '/priceAgreementPart/updatePriceAgreementPartList', params)
}
export function removePriceAgreementPartList(params,pathParam) {
    return get(SERVICE_URL + '/priceAgreementPart/deletePriceAgreementPartList', params,pathParam)
}

export function exportPriceArgument(params) {
    return post(SERVICE_URL + '/priceAgreement/export', params)
}
export function pushSapBack(params) {
    return post(SERVICE_URL + '/priceAgreement/pushSapBack', params)
}
export function pushSapBackPrice(params) {
    return post(SERVICE_URL + '/priceAgreement/pushSapBackPrice', params)
}
export function checkDate(params) {
    return post(SERVICE_URL + '/priceAgreement/checkDate', params)
}
export function importPartTemplate(params) {
    return upload(SERVICE_URL + '/priceAgreement/importPartTemplate', params)
}
//导出模板
export function exportTemplate() {
	return post(SERVICE_URL + '/priceAgreement/exportTemplate')
}
//价格协议导入
export function importPriceAgreement(params) {
    return upload(SERVICE_URL + '/uploadFile/importPriceAgreement', params)
}
//价格协议查询导出
export function exportPriceAgreement(params) {
    return post(SERVICE_URL + '/uploadFile/exportPriceAgreement', params)
}
// 根据Id查询数据
export function selectPriceAgreementById(params, pathParam) {
    return get(SERVICE_URL + '/priceAgreement/getPriceAgreementById', params, pathParam)
}
//修改画面table
export function getPriceAgreementListUpdate(params) {
    return post(SERVICE_URL + '/priceAgreement/getPriceAgreementListUpdate', params)
}
//从价格协议表提取已审批通过的数据
export function getPriceAgreementSupplierList(params) {
    return post(SERVICE_URL + '/priceAgreement/getPriceAgreementSupplierList', params)
}
/** 获取当前登录人对应的采购组织 接口 } /position/getCurrentUserPurOrg*/
export function getCurrentUserPurOrg(params) {
    return get(SERVICE_URL1 + '/org/purList', params)}

/** 获取所选组织下的工厂 接口 } /position/getCurrentUserPurOrg*/
export function getWerkList(params, pathParam) {
    return get(SERVICE_URL1 + '/org/werkList', params, pathParam)}